import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';
import { isString } from 'lodash';

import { TextLine } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { CostSourceHelper } from 'pricing/helpers';
import { QuotePartColId } from 'quotes/components';
import { ICustomerQuotePart } from 'quotes/types';
import { getEffectiveSpaInfo } from 'quotes/utils';

import { CostSource } from './CostSource';
import { ExternalPricingSourceTooltip } from './ExternalPricingSourceTooltip';

export const CostSourceCell = (params: ICellRendererParams) => {
  const data = getAgGridTableCellData(params, QuotePartColId.COST_SOURCE);
  if (!data) {
    const displayValue = isString(params?.value) ? params?.value : params?.value[0];

    return <TextLine text={displayValue} bold textEllipsis />;
  }

  const { costSourceId } = data as ICustomerQuotePart;

  if (!costSourceId) {
    return <TextLine text={t('messageNoCost')} bold />;
  }

  const isGroupedByColumn = QuotePartColId.COST_SOURCE === params?.node?.rowGroupColumn?.getColId();

  const costSourceLabel = CostSourceHelper.getTypeLabel(data);

  if (isGroupedByColumn) {
    return <TextLine text={costSourceLabel.long} bold textEllipsis />;
  }

  const effectiveSpa = getEffectiveSpaInfo(data);

  return (
    <ExternalPricingSourceTooltip
      pricingData={effectiveSpa.pricingData}
      spaCostCurrency={effectiveSpa.spaCostCurrency}
      isAlternateVersionEnabled={Boolean(data.alternateVersionEnabled)}
    >
      <CostSource costSource={data} />
    </ExternalPricingSourceTooltip>
  );
};
